@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&family=Source+Serif+4:ital,opsz,wght@0,8..60,200..900;1,8..60,200..900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');
@import "tailwindcss";

/* Turkish Character Rendering Fix */
.rendering-legibility {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Prevent horizontal scroll on mobile */
html, body {
  overflow-x: hidden;
  max-width: 100vw;
  position: relative;
}

html[lang="tr"], 
[lang="tr"] {
  font-variant-ligatures: none;
  text-rendering: optimizeLegibility;
}

@custom-variant dark (&:is(.dark *));

/* ========================================================
   MAYI MIMARLIK PUBLIC SITE LEGACY CSS VARIABLES
   These were accidentally removed during the SaaS migration.
   They are required by Navbar.css, Footer.css, and others.
======================================================== */
:root {
  --bg-primary: #ffffff;
  --bg-secondary: #f8f8f8;
  --text-primary: #111111;
  --text-secondary: #555555;
  --text-muted: #999999;
  --accent-gold: #d4af37; /* Orijinal Mayi Mimarlık Yaldızı */
  
  --border-color: rgba(0,0,0,0.08);
  
  --spacing-xs: 0.25rem;
  --spacing-sm: 0.5rem;
  --spacing-md: 1rem;
  --spacing-lg: 1.5rem;
  --spacing-xl: 2rem;
  --spacing-2xl: 3rem;
  --spacing-3xl: 4rem;
  --spacing-4xl: 5rem;
  
  --radius-sm: 4px;
  --radius-md: 8px;
  --radius-lg: 12px;
  
  --header-height: 80px;
  --font-heading: 'Outfit', 'Plus Jakarta Sans', sans-serif;
}

/* ========================================================
   SAAS ADMIN PANEL VARIABLES (Light Mode)
======================================================== */
:root {
  --background: oklch(0.98 0 0); /* Hafif kirli beyaz */
  --foreground: oklch(0.15 0 0);
  --card: oklch(1.0000 0 0);
  --card-foreground: oklch(0.15 0 0);
  --popover: oklch(1.0000 0 0);
  --popover-foreground: oklch(0.15 0 0);
  
  /* GÜNDÜZ MODU: SLATE-900 (Gece Yarısı Mavisi) */
  --primary: oklch(0.2105 0.034 264.6);
  --primary-foreground: oklch(0.98 0 0);
  
  --secondary: oklch(0.96 0 0);
  --secondary-foreground: oklch(0.2105 0.034 264.6);
  --muted: oklch(0.96 0 0);
  --muted-foreground: oklch(0.55 0 0);
  --accent: oklch(0.96 0 0);
  --accent-foreground: oklch(0.2105 0.034 264.6);
  --destructive: oklch(0.6368 0.2078 25.3313);
  --destructive-foreground: oklch(1.0000 0 0);
  --border: oklch(0.92 0 0);
  --input: oklch(0.92 0 0);
  --ring: oklch(0.2105 0.034 264.6);
  --chart-1: oklch(0.2105 0.034 264.6);
  --chart-2: oklch(0.5461 0.2152 262.8809);
  --chart-3: oklch(0.4882 0.2172 264.3763);
  --chart-4: oklch(0.4244 0.1809 265.6377);
  --chart-5: oklch(0.3791 0.1378 265.5222);
  --sidebar: oklch(0.98 0 0);
  --sidebar-foreground: oklch(0.15 0 0);
  --sidebar-primary: oklch(0.2105 0.034 264.6);
  --sidebar-primary-foreground: oklch(0.98 0 0);
  --sidebar-accent: oklch(0.96 0 0);
  --sidebar-accent-foreground: oklch(0.2105 0.034 264.6);
  --sidebar-border: oklch(0.92 0 0);
  --sidebar-ring: oklch(0.2105 0.034 264.6);
  
  /* Yeni SaaS Fontu: Plus Jakarta Sans */
  --font-sans: 'Plus Jakarta Sans', sans-serif;
  --font-serif: 'Source Serif 4', serif;
  --font-mono: 'JetBrains Mono', monospace;
  
  /* Keskinleştirilmiş Köşe Yarıçapı (Premium Hissiyat) */
  --radius: 0.5rem;
}

/* ── LANDING PAGE ÖZEL TEMASI ─────────────────────────────────
   Karsilama.tsx'in root div'ine .landing class'ı uygulanır.
   --primary burada koyu zemin üzerinde parlayan mor/indigo ton olarak
   tanımlanır; böylece text-primary, bg-primary, from-primary vs. hepsi
   canlı görünür — ne bembeyaz, ne koyu lacivert.
──────────────────────────────────────────────────────────────── */
.landing {
  --primary: oklch(0.65 0.22 270);           /* Canlı indigo/mor vurgu */
  --primary-foreground: oklch(1 0 0);        /* Beyaz yazı buton içi    */
  --foreground: oklch(0.97 0 0);
  --muted-foreground: oklch(0.70 0 0);
}

.dark {
  --background: oklch(0.15 0 0); /* Asil Kurşuni Gri Zemin */
  --foreground: oklch(0.98 0 0); /* Beyaz Metin */
  --card: oklch(0.20 0 0); /* Kartlar Zeminden Biraz Daha Açık */
  --card-foreground: oklch(0.98 0 0);
  --popover: oklch(0.20 0 0);
  --popover-foreground: oklch(0.98 0 0);
  
  /* GECE MODU: SLATE-50 (Bembeyaz Asil Butonlar) */
  --primary: oklch(0.98 0 0);
  --primary-foreground: oklch(0.15 0 0); /* Beyaz butonun içindeki siyah yazı */
  
  --secondary: oklch(0.25 0 0);
  --secondary-foreground: oklch(0.98 0 0);
  --muted: oklch(0.25 0 0);
  --muted-foreground: oklch(0.65 0 0);
  --accent: oklch(0.25 0 0);
  --accent-foreground: oklch(0.98 0 0);
  --destructive: oklch(0.6368 0.2078 25.3313);
  --destructive-foreground: oklch(1.0000 0 0);
  --border: oklch(0.25 0 0); /* Belirginleştirilmiş Kart Kenarlıkları */
  --input: oklch(0.25 0 0);
  --ring: oklch(0.98 0 0);
  --chart-1: oklch(0.7137 0.1434 254.6240);
  --chart-2: oklch(0.6231 0.1880 259.8145);
  --chart-3: oklch(0.5461 0.2152 262.8809);
  --chart-4: oklch(0.4882 0.2172 264.3763);
  --chart-5: oklch(0.4244 0.1809 265.6377);
  --sidebar: oklch(0.15 0 0);
  --sidebar-foreground: oklch(0.98 0 0);
  --sidebar-primary: oklch(0.98 0 0);
  --sidebar-primary-foreground: oklch(0.15 0 0);
  --sidebar-accent: oklch(0.25 0 0);
  --sidebar-accent-foreground: oklch(0.98 0 0);
  --sidebar-border: oklch(0.25 0 0);
  --sidebar-ring: oklch(0.98 0 0);
}

@theme inline {
  --color-background: var(--background);
  --color-foreground: var(--foreground);
  --color-card: var(--card);
  --color-card-foreground: var(--card-foreground);
  --color-popover: var(--popover);
  --color-popover-foreground: var(--popover-foreground);
  --color-primary: var(--primary);
  --color-primary-foreground: var(--primary-foreground);
  --color-secondary: var(--secondary);
  --color-secondary-foreground: var(--secondary-foreground);
  --color-muted: var(--muted);
  --color-muted-foreground: var(--muted-foreground);
  --color-accent: var(--accent);
  --color-accent-foreground: var(--accent-foreground);
  --color-destructive: var(--destructive);
  --color-destructive-foreground: var(--destructive-foreground);
  --color-border: var(--border);
  --color-input: var(--input);
  --color-ring: var(--ring);
  --color-chart-1: var(--chart-1);
  --color-chart-2: var(--chart-2);
  --color-chart-3: var(--chart-3);
  --color-chart-4: var(--chart-4);
  --color-chart-5: var(--chart-5);
  --color-sidebar: var(--sidebar);
  --color-sidebar-foreground: var(--sidebar-foreground);
  --color-sidebar-primary: var(--sidebar-primary);
  --color-sidebar-primary-foreground: var(--sidebar-primary-foreground);
  --color-sidebar-accent: var(--sidebar-accent);
  --color-sidebar-accent-foreground: var(--sidebar-accent-foreground);
  --color-sidebar-border: var(--sidebar-border);
  --color-sidebar-ring: var(--sidebar-ring);

  --font-sans: var(--font-sans);
  --font-serif: var(--font-serif);
  --font-mono: var(--font-mono);

  /* Radius Çarpanlarını Düzelttik */
  --radius-lg: var(--radius);
  --radius-md: calc(var(--radius) - 2px);
  --radius-sm: calc(var(--radius) - 4px);
  --radius-xl: var(--radius); /* Tablolar ve kartlar çok büyümesin */
  --radius-2xl: var(--radius);
  --radius-3xl: var(--radius);
  --radius-4xl: var(--radius);
}

@layer base {
  *, ::before, ::after {
    border-color: var(--border);
    outline-color: var(--ring);
  }
  html {
    scrollbar-gutter: stable;
  }
  body {
    background-color: var(--background);
    color: var(--foreground);
    font-family: var(--font-sans);
    -webkit-font-smoothing: antialiased;
  }
  body[data-scroll-locked] {
    padding-right: 0 !important;
    margin-right: 0 !important;
  }
  button, input, select, textarea {
    border-radius: var(--radius) !important;
  }
}

/* PDF MODE OVERRIDES */
html.pdf-mode, .pdf-mode {
  --background: oklch(1.0000 0 0) !important;
  --foreground: oklch(0.15 0 0) !important;
  --card: oklch(1.0000 0 0) !important;
  --card-foreground: oklch(0.15 0 0) !important;
  --popover: oklch(1.0000 0 0) !important;
  --popover-foreground: oklch(0.15 0 0) !important;
  --secondary: oklch(0.96 0 0) !important;
  --secondary-foreground: oklch(0.2105 0.034 264.6) !important;
  --muted: oklch(0.96 0 0) !important;
  --muted-foreground: oklch(0.55 0 0) !important;
  --accent: oklch(0.96 0 0) !important;
  --accent-foreground: oklch(0.2105 0.034 264.6) !important;
  --border: oklch(0.92 0 0) !important;
  --input: oklch(0.92 0 0) !important;
}

.grecaptcha-badge { 
  visibility: hidden !important; 
}

/* ── Auth Sayfaları Özel Scope ────────────────────────────────────────────── */
/* Login / Register sayfaları her zaman koyu arka plana sahip.                */
/* Bu scope içindeki elementler light/dark bağımsız mavi renk kullanır.       */
.auth-page {
  --auth-accent: oklch(0.62 0.21 260);        /* Canlı mavi */
  --auth-accent-hover: oklch(0.70 0.18 260);  /* Daha açık mavi */
  --color-auth-accent: var(--auth-accent);
  --color-auth-accent-hover: var(--auth-accent-hover);
}
.auth-page .auth-link {
  color: var(--auth-accent);
  transition: color 0.15s ease;
}
.auth-page .auth-link:hover {
  color: var(--auth-accent-hover);
}

/* ── Buton Hover Glow Sistemi ─────────────────────────────────────────────── */
/* Tüm butonlarda box-shadow transition: akıcı ve premium hissiyat             */
:not(.pdf-mode) button[data-slot="button"] {
  transition: box-shadow 0.22s ease, opacity 0.15s ease;
}

/* PRIMARY (variant="default") — koyu/beyaz dolgu butonu                      */
/* Rest: hafif alt glow; Hover: daha kuvvetli, yukarı kalkan ışıltı            */
:not(.pdf-mode) button[data-slot="button"]:not([class*="outline"]):not([class*="ghost"]):not([class*="secondary"]):not([class*="destructive"]) {
  box-shadow:
    0 2px 8px -3px oklch(from var(--primary) l c h / 0.30),
    0 1px 2px -1px oklch(from var(--primary) l c h / 0.15);
}
:not(.pdf-mode) button[data-slot="button"]:not([class*="outline"]):not([class*="ghost"]):not([class*="secondary"]):not([class*="destructive"]):hover:not(:disabled) {
  box-shadow:
    0 0px 0px 0px transparent,           /* alt glow kalkar   */
    0 -2px 16px -2px oklch(from var(--primary) l c h / 0.50),   /* üst hale  */
    0  6px 20px -4px oklch(from var(--primary) l c h / 0.45),   /* alt iz    */
    0  1px  4px -1px oklch(from var(--primary) l c h / 0.20);   /* yakın     */
}

/* OUTLINE / SECONDARY — kenarlıklı veya soluk zemin butonlar                 */
/* Rest: glow yok; Hover: zarif ince ambient hale                              */
:not(.pdf-mode) button[data-slot="button"][class*="outline"]:hover:not(:disabled),
:not(.pdf-mode) button[data-slot="button"][class*="secondary"]:hover:not(:disabled) {
  box-shadow:
    0 4px 14px -4px oklch(from var(--primary) l c h / 0.20),
    0 1px  4px -2px oklch(from var(--primary) l c h / 0.12);
}
:root {
  --bg-primary: #fff;
  --bg-secondary: #f4f4f5;
  --bg-tertiary: #e4e4e7;
  --text-primary: #1e281d;
  --text-secondary: #4a554a;
  --text-muted: #71717a;
  --accent-gold: #b99745;
  --accent-gold-hover: #9c7f39;
  --white: #fff;
  --primary: #1a1a1a;
  --brand-creavit: #0056b3;
  --brand-qua: #333;
  --brand-duratiles: #c00;
  --brand-vitrafix: #08c;
  --border-color: #e4e4e7;
  --font-sans: "Inter", sans-serif;
  --font-heading: "Outfit", sans-serif;
  --spacing-xs: 0.25rem;
  --spacing-sm: 0.5rem;
  --spacing-md: 1rem;
  --spacing-lg: 1.5rem;
  --spacing-xl: 2rem;
  --spacing-2xl: 3rem;
  --spacing-3xl: 4rem;
  --spacing-4xl: 6rem;
  --radius-sm: 0.25rem;
  --radius-md: 0.5rem;
  --radius-lg: 1rem;
  --radius-xl: 1.5rem;
  --header-height: 80px;
}
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
body {
  font-family: var(--font-sans);
  background-color: var(--bg-primary);
  color: var(--text-primary);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 1.6;
  overflow-x: hidden;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: var(--font-heading);
  font-weight: 600;
  line-height: 1.2;
}
a {
  color: inherit;
  text-decoration: none;
  transition: color 0.2s;
}
a:hover {
  color: var(--accent-gold);
}
button {
  cursor: pointer;
  color: inherit;
  background: 0 0;
  border: none;
  font-family: inherit;
}
.container {
  max-width: 1280px;
  padding: 0 var(--spacing-xl);
  margin: 0 auto;
}
.flex-col {
  flex-direction: column;
}
.justify-between {
  justify-content: space-between;
}
.gap-sm {
  gap: var(--spacing-sm);
}
.gap-lg {
  gap: var(--spacing-lg);
}
.text-xs {
  font-size: 0.75rem;
}
.text-sm {
  font-size: 0.875rem;
}
.text-base {
  font-size: 1rem;
}
.text-lg {
  font-size: 1.125rem;
}
.text-xl {
  font-size: 1.25rem;
}
.text-2xl {
  font-size: 1.5rem;
}
.text-3xl {
  font-size: 1.875rem;
}
.text-4xl {
  font-size: 2.25rem;
}
.text-5xl {
  font-size: 3rem;
}
.font-light {
  font-weight: 300;
}
.font-normal {
  font-weight: 400;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.font-bold {
  font-weight: 700;
}
.text-primary {
  color: var(--text-primary);
}
.text-secondary {
  color: var(--text-secondary);
}
.text-muted {
  color: var(--text-muted);
}
.text-accent {
  color: var(--accent-gold);
}
.btn {
  padding: var(--spacing-md) var(--spacing-xl);
  border-radius: var(--radius-md);
  justify-content: center;
  align-items: center;
  gap: var(--spacing-sm);
  font-weight: 500;
  transition: all 0.3s;
  display: inline-flex;
}
.btn-primary {
  background-color: var(--accent-gold);
  color: var(--bg-primary);
}
.btn-primary:hover {
  background-color: var(--accent-gold-hover);
  color: var(--bg-primary);
  transform: translateY(-2px);
}
.btn-outline {
  border: 1px solid var(--accent-gold);
  color: var(--accent-gold);
}
.btn-outline:hover {
  background-color: var(--accent-gold);
  color: var(--bg-primary);
}
.btn-ghost {
  color: var(--text-secondary);
}
.btn-ghost:hover {
  color: var(--text-primary);
  background-color: var(--bg-secondary);
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.glass {
  -webkit-backdrop-filter: blur(12px);
  background: #ffffffd9;
  border: 1px solid #0000000d;
  box-shadow: 0 4px 30px #0000000d;
}
@media (width<=768px) {
  .container {
    padding: 0 var(--spacing-md);
  }
  .md-hidden {
    display: none;
  }
}
